module.exports = __webpack_public_path__ + "static/visit-stats-5133674c23de7c355ee166b3649bef57.gif";